var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{class:`d-flex ${_vm.filiais.length > 7 ?  'justify-space-between' : ''} flex-wrap`},_vm._l((_vm.filiais),function(filial,index){return _c('div',{key:index},[_c('pm-resumo-dia',{key:filial.id_reg,attrs:{"filial":filial.cc_fil}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }